import { effect, EffectRef, inject, Injectable, Signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslocoService } from '@jsverse/transloco';
import { Observable, of } from 'rxjs';
import { ServerViolation } from '../store-features/with-server-errors-handling';
import { defaultErrors, fileErrors, FORM_ERRORS } from './default-errors';

@Injectable({
  providedIn: 'root',
})
export class FormUtilsService {
  #translator = inject(TranslocoService);
  #defaultErrors = inject(FORM_ERRORS);

  getErrorMessage(
    key: string,
    interpolateParams?: Record<string, string | number>,
    customErrors: Record<string, string> = {},
  ): Observable<string> {
    if (customErrors[key]) {
      return of(customErrors[key]);
    }

    if (defaultErrors[key]) {
      return this.#translator.selectTranslate(this.#defaultErrors[key], interpolateParams);
    }

    return this.#translator.selectTranslate(this.#defaultErrors['unknown']);
  }

  /**
   * Replace empty string fields with null.
   */
  // eslint-disable-next-line
  static emptyFieldsToNull(obj: any) {
    for (const f in obj) {
      const p = obj[f];
      if (p === '') {
        obj[f] = null;
      } else if (typeof p === 'object' && p !== null) {
        this.emptyFieldsToNull(p);
      }
    }
  }

  static initializeServerErrorsHandling(violations: Signal<ServerViolation[]>, form: FormGroup): EffectRef {
    return effect(() => {
      violations().forEach((error) => {
        // TODO: add mapper for other codes nad use it?
        switch (error.code) {
          case '23bd9dbf-6b9b-41cd-a99e-4844bcf3077f':
            form.get(error.propertyPath)?.setErrors({ objectNotUnique: true });
            break;
          default:
            form.get(error.propertyPath)?.setErrors({ unknown: true });
            break;
        }
      });
    });
  }

  static getFileErrorMessageByCode(code: string) {
    switch (code) {
      case 'd2a3fb6e-7ddc-4210-8fbf-2ab345ce1998':
        return fileErrors['notFound'];
      case 'c20c92a4-5bfa-4202-9477-28e800e0f6ff':
        return fileErrors['notReadable'];
      case '5d743385-9775-4aa5-8ff5-495fb1e60137':
        return fileErrors['empty'];
      case 'df8637af-d466-48c6-a59d-e7126250a654':
        return fileErrors['tooLarge'];
      case '744f00bc-4389-4c74-92de-9a43cde55534':
        return fileErrors['invalidMimeType'];
      case 'c8c7315c-6186-4719-8b71-5659e16bdcb7':
        return fileErrors['invalidExtension'];
      case 'e5706483-91a8-49d8-9a59-5e81a3c634a8':
        return fileErrors['filenameTooLong'];
      case '04ee58e1-42b4-45c7-8423-8a4a145fedd9':
        return fileErrors['filenameInvalidCharacters'];
      default:
        return fileErrors['unknownError'];
    }
  }
}
